import { render } from "./judgmentList.vue?vue&type=template&id=c7a1e7d2"
import script from "./judgmentList.vue?vue&type=script&lang=js"
export * from "./judgmentList.vue?vue&type=script&lang=js"

import "./judgmentList.vue?vue&type=style&index=0&id=c7a1e7d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__